import { Component } from '@angular/core';
import { UserService } from 'src/app/core/common-services/user.services';
import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { Router } from '@angular/router';
import { FundDataService } from 'src/app/core/data-services/fund/fund.data.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { EFundStatus, FundTypeEnum, OpportunityItemDto } from 'src/app/core/data-models/opportunity.data.models';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  color: ThemePalette = 'primary';
  mode: ProgressBarMode = 'determinate';
  opportunities: OpportunityItemDto[] = [];
  filterFundStatus: EFundStatus = EFundStatus.Current;
  filterFundType?: FundTypeEnum ;
  fundStatus = EFundStatus;
  fundTypes = FundTypeEnum;

  constructor(
    private router: Router,
    private userService: UserService,
    private fundDataService: FundDataService,
    private notificationService: NotificationService,
    public languageService: LanguageService,

  ) { }

  ngOnInit() {
    this.getOpportunities();
  }

  getOpportunities() {
    this.fundDataService.GetAllOpportunities(this.filterFundStatus, this.filterFundType, 1, 6).subscribe({
      next: (res) => {
        this.opportunities = res.resource.items.filter(item => !item.isCompleted && item.soldPercentage < 100);
      },
      error: (err) => {
        this.notificationService.error(err.message!)
      }
    });
  }

  filter(fundType: EFundStatus, fundTypeEnum?: FundTypeEnum) {
    this.filterFundType = fundTypeEnum;
    this.filterFundStatus = fundType;
    this.getOpportunities();
  }
  redirectToLogin() {
    this.router.navigate(['authentication/login']);
  }
}
